import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { StorageService, StorageServiceKey, StorageType } from '@services/storage';

import { ISideMenuItem } from './side-menu.models';

@Component({
	selector: 'app-side-menu',
	templateUrl: './side-menu.component.html',
	styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements AfterViewInit {
	@ViewChild('sidenav') sidenav: MatSidenav;

	@Input() homeItem: ISideMenuItem;
	@Input() menuItems: ISideMenuItem[] = [];
	@Input() stateKey = StorageServiceKey.sideNavOpenState;

	sideMenuOpen = true;
	storage = StorageType.localStorage;

	constructor(private storageService: StorageService) {}

	ngAfterViewInit(): void {
		const isOpen = this.storageService.getItem(this.storage, this.stateKey)
			? this.storageService.getItem(this.storage, this.stateKey) === 'true'
			: this.sideMenuOpen;

		setTimeout(() => {
			if (isOpen) {
				this.openSide();
			} else {
				this.closeSide();
			}
		});
	}

	closeSide() {
		this.sidenav.close();
		this.storageService.setItem(this.storage, this.stateKey, false);

		setTimeout(() => {
			this.sideMenuOpen = false;
		});
	}

	openSide() {
		this.sideMenuOpen = true;
		this.sidenav.open();
		this.storageService.setItem(this.storage, this.stateKey, true);
	}
}
